import { TOGGLE_PARTICIPANT_RIGHT } from "./actionType";

export function toggleParticipantRight(isOpen) {
    return {
        type: TOGGLE_PARTICIPANT_RIGHT,
        data: isOpen
    }
}